
import React from 'react';
import { ConfigProvider, App as AntApp, message } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ThreeColumnLayout from './components/ThreeColumnLayout';
import ErrorBoundary from './components/ErrorBoundary';
import LoginPage from './pages/Login';
import AdminDashboard from './pages/Admin';
import PortalPage from './pages/Portal';
import './App.css';

// 路由守卫组件
const PrivateRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const token = localStorage.getItem('auth_token');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return element;
};

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <AntApp>
        <ErrorBoundary>
          <BrowserRouter>
            <Routes>
              {/* 登录路由 */}
              <Route path="/login" element={<LoginPage />} />
              
              {/* 门户导航路由 (受保护) */}
              <Route path="/portal" element={
                <PrivateRoute element={<PortalPage />} />
              } />

              {/* 主界面路由 (受保护) */}
              <Route path="/" element={
                <PrivateRoute element={
                  <div className="App">
                    <ThreeColumnLayout />
                  </div>
                } />
              } />
              
              {/* 管理后台路由 (受保护) */}
              <Route path="/admin" element={
                <PrivateRoute element={<AdminDashboard />} />
              } />
              
              {/* 默认跳转 */}
              <Route path="*" element={<Navigate to="/portal" replace />} />
            </Routes>
          </BrowserRouter>
        </ErrorBoundary>
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
